const stateByOwner = new WeakMap();
const getState = owner => {
  if (!stateByOwner.has(owner)) {
    stateByOwner.set(owner, {
      tail: Promise.resolve(),
      confirmed: new Map(),
      pending: new Map(),
      owed: new Set()
    });
  }
  return stateByOwner.get(owner);
};
export const enqueueMethodSave = (owner, _ref) => {
  var _state$pending$get;
  let id = _ref.id,
    methodBefore = _ref.methodBefore,
    methodSent = _ref.methodSent,
    run = _ref.run,
    onRefused = _ref.onRefused;
  const state = getState(owner);
  const pendingCount = (_state$pending$get = state.pending.get(id)) !== null && _state$pending$get !== void 0 ? _state$pending$get : 0;
  if (!pendingCount) state.confirmed.set(id, methodBefore);
  state.pending.set(id, pendingCount + 1);
  const result = state.tail.then(async () => {
    const resp = await run();
    if (resp !== undefined) {
      state.confirmed.set(id, methodSent);
      state.owed.delete(id);
    } else {
      const isLatest = state.pending.get(id) === 1;
      const rollbackNeeded = onRefused(state.confirmed.get(id), isLatest, state.owed.has(id));
      if (rollbackNeeded && !isLatest) state.owed.add(id);
    }
    return resp;
  }).finally(() => {
    const remaining = state.pending.get(id) - 1;
    if (remaining) {
      state.pending.set(id, remaining);
    } else {
      state.pending.delete(id);
      state.confirmed.delete(id);
      state.owed.delete(id);
    }
  });
  state.tail = result.catch(() => undefined);
  return result;
};